"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clusterService = void 0;
var clusterService_1 = require("./clusterService");
Object.defineProperty(exports, "clusterService", { enumerable: true, get: function () { return __importDefault(clusterService_1).default; } });
